function BeerPouring3(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={65}
      height={130}
      id="beer-pouring-3"
      viewBox="0 0 65 130"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.057 2.47h63.191c.546 50.866-22.735 101.7-11.818 125.233A2.313 2.313 0 0150.126 130H15.18a2.312 2.312 0 01-2.302-2.297C23.795 104.17.514 53.336 1.058 2.469z"
        fill="#C0BFBF"
      />
      <path
        d="M3.219 4.438h58.875c0 52.421-17.945 87.162-13.46 115.412H16.679C21.164 91.6 3.218 56.86 3.218 4.438z"
        fill="#D4D4D4"
      />
      <path
        d="M30.262 94.464a2.384 2.384 0 002.388 2.382c1.32 0 2.39-1.066 2.39-2.382 0-1.314-1.07-2.38-2.39-2.38a2.384 2.384 0 00-2.388 2.38z"
        fill="#D4D4D4"
      />
      <path
        d="M44.618 59.911a3.124 3.124 0 003.128 3.118 3.123 3.123 0 003.129-3.118c0-1.724-1.4-3.12-3.129-3.12a3.125 3.125 0 00-3.128 3.12z"
        fill="#F8F8F8"
      />
      <path
        d="M32.652 130h17.473a2.313 2.313 0 002.304-2.297c-2.079-4.482-2.919-9.952-2.917-16.227.002-26.281 14.742-66.636 14.746-107.218 0-.597-.004-1.192-.01-1.789H32.652v1.968H62.09C62.09 56.86 44.145 91.6 48.63 119.85H32.652V130z"
        fill="#999"
      />
      <path
        d="M32.656 119.85h15.979C44.149 91.6 62.094 56.86 62.094 4.438H32.656v87.647c1.32 0 2.39 1.065 2.39 2.38a2.385 2.385 0 01-2.39 2.381v23.004zm15.096-63.062a3.123 3.123 0 013.128 3.12c0 1.723-1.4 3.12-3.129 3.12a3.124 3.124 0 01-3.128-3.12 3.125 3.125 0 013.129-3.12z"
        fill="#D4D4D4"
      />
      <path
        d="M32.65 96.846c1.32 0 2.39-1.066 2.39-2.382 0-1.314-1.07-2.38-2.39-2.38v4.762zM47.746 63.03a3.123 3.123 0 003.129-3.119c0-1.724-1.4-3.12-3.129-3.12a3.125 3.125 0 00-3.128 3.12 3.124 3.124 0 003.128 3.118z"
        fill="#D4D4D4"
      />
      <path
        d="M10.2 5.543H4.793c-.692 32.6 15.105 75.56 14.275 113.409C22.117 67.704 9.565 53.85 10.2 5.543z"
        fill="#F8F8F8"
      />
      <path
        d="M43.594 41.268c0 1.745.93 3.16 2.077 3.16 1.148 0 2.079-1.415 2.079-3.16 0-1.746-.93-3.16-2.08-3.16-1.145 0-2.076 1.414-2.076 3.16zM19.983 35.778a3.125 3.125 0 003.13 3.118 3.124 3.124 0 003.13-3.118 3.125 3.125 0 00-3.13-3.12 3.125 3.125 0 00-3.13 3.12zM20.976 25.023a4.193 4.193 0 004.2 4.186c2.32 0 4.199-1.874 4.199-4.186 0-2.311-1.88-4.187-4.2-4.187a4.195 4.195 0 00-4.2 4.187z"
        fill="#D4D4D4"
      />
      <ellipse cx={32.713} cy={3.277} rx={31.744} ry={3.277} fill="#F8F8F8" />
      <path
        d="M50.932 87.438s3.886-9.917-1.807-14.05c-1.694-1.23-6.372-.617-11.178-.006-4.915-1.68-5.51-3.916-7.925-3.993-6.617-.212-10.711 1.72-14.512 4.413-3.764 3.719.005 13.636.005 13.636h35.417z"
        fill="#F8F8F8"
      />
      <path
        d="M14.586 84.804c4.516 21.828 2.07 33.494 1.705 35.367H49.13s-.895-5.709-1.048-9.399c-.346-8.28 2.634-24.087 2.634-24.087s-15.43-6.774-22.581-2.634c-7.151 4.14-13.55.753-13.55.753z"
        fill="url(#prefix__paint0_linear_14338_42016)"
      />
      <path
        d="M22.488 91.954a1.129 1.129 0 100-2.257 1.129 1.129 0 000 2.257zM40.558 113.783a1.128 1.128 0 10.002-2.257 1.128 1.128 0 00-.002 2.257zM41.684 95.718a1.505 1.505 0 103.011 0 1.505 1.505 0 00-3.01 0zM25.874 103.998a2.257 2.257 0 104.515.001 2.257 2.257 0 00-4.515-.001z"
        fill="#F8F8F8"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_14338_42016"
          x1={49.211}
          y1={116.041}
          x2={16.091}
          y2={116.041}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAAF3F" />
          <stop offset={1} stopColor="#F89730" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default BeerPouring3;
